import React from 'react';

import { CONTEXT_PATH } from '@confluence/named-routes';

import { Breadcrumbs } from './Breadcrumbs';
import type { EditorBreadcrumbsLinksProps } from './breadcrumbTypes';

const PEOPLE_DIR = `${CONTEXT_PATH}/peopledirectory.action`;

export const EditorBreadcrumbsLinks = ({
	breadcrumbs,
	contentType,
	contentId,
	breadcrumbsClickHandler,
	origin,
	disabled,
}: EditorBreadcrumbsLinksProps) => {
	if (!breadcrumbs || breadcrumbs.length === 0) {
		return null;
	}

	// Remove the People link
	if (breadcrumbs[0].url === PEOPLE_DIR) {
		breadcrumbs = breadcrumbs.slice(1);
	}

	if (contentType === 'blogpost') {
		// remove year, month, date, and do not truncate
		const yearIndex = breadcrumbs.findIndex((x) => !x.url && x.title?.match(/^\d{4}$/));
		if (yearIndex !== -1) {
			breadcrumbs = [...breadcrumbs];
			breadcrumbs.splice(yearIndex, 3);
		}
		return (
			<Breadcrumbs
				contentType={contentType}
				breadcrumbs={breadcrumbs}
				clickHandler={breadcrumbsClickHandler}
				origin={origin}
				disabled={disabled}
			/>
		);
	} else {
		// Show both Parent and Page, or just Parent if current page is not in breadcrumbs
		let after = 1;
		if (breadcrumbs.length > 0) {
			const last = breadcrumbs[breadcrumbs.length - 1];
			if (
				last.url &&
				new RegExp(`(/pages/|/resumedraft.action\\?draftId=)${contentId}\\b`).test(last.url)
			) {
				after = 2;
			}
		}

		// Add one for the truncation "..." element
		const maxItems = after + 2;
		return (
			<Breadcrumbs
				breadcrumbs={breadcrumbs}
				maxItems={maxItems}
				itemsBeforeCollapse={1}
				itemsAfterCollapse={after}
				clickHandler={breadcrumbsClickHandler}
				origin={origin}
				disabled={disabled}
			/>
		);
	}
};
